// extracted by mini-css-extract-plugin
module.exports = {"tag":"PreviewTag_tag__1LQCt"};